import { render, staticRenderFns } from "./Paarivallal.vue?vue&type=template&id=5a49431c"
import script from "./Paarivallal.vue?vue&type=script&lang=js"
export * from "./Paarivallal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports